<template>
  <div>
    <Modal v-model="isShow" width="65%" :closable="false" :mask-closable="false" :footerHide="true">
      <div>
        <div slot="header" class="info-header">
          <div class="ivu-modal-header-inner">服务协议</div>
          <a class="ivu-modal-close" @click="closeModel"><i class="ivu-icon ivu-icon-ios-close"></i></a>
        </div>
        <h3> 更新时间：2023/4/3</h3>
          智析是一个在线解析和生产文件平台，平台凭借先进及优秀的技术团队，不断为用户提供更好更优秀的转换体验，始终坚持简单便捷的理念打造更优秀的转换流程，为我们的用户提供更多类型的数字化文件处理功能。
        <h4>更好的服务</h4>
        智析目前已有Excel、Word、pdf生成，PDF转Excel等多种转换功能，努力为用户提供更高质量的文件解析和生产，同时不断开发更多功能，满足更多用户的需求。
        <h4>更安全的隐私保护</h4>
        文件上传默认24小时后自动删除，解析数据仅您自己可以查看，100%保护您的隐私，如果需要删除请自己删除，删除后，本服务不提供任何备份和恢复。
        <h4>更高效的转化模式</h4>
        您可以在智析批量转换您的文件，而不需要重复添加单个文件，同时为了更高效的节省您的时间，我们保证质量的情况下，极大的缩短了文档转换所需时间。在智析您可以自由管理您的文件，您也可随时进行删除。
        <h4>希望您可以让更多的朋友使用</h4>
        为了更好的改进智析转换的功能，希望您可以让更多的朋友使用智析，伴随智析一起进步，一起共创更好的文档解析平台！
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: 'service',
  components: {},
  data () {
    return {
      isShow: false
    }
  },
  methods: {
    openModel (type, data) {
      this.isShow = true
    },
    closeModel () {
      this.isShow = false
    }
  }
}
</script>
